import { CCCOLORID, IMG_URI } from 'src/utils/Domain/Constants';

export interface ColorSwatchItem {
  type: string;
  name?: string;
  description?: string;
  swatchPath: string;
  id: string;
  colorId: string;
  /** This property is expected and essentially required to exist for some "in assortment" checks */
  [CCCOLORID]?: string;
  /** This property is also essentially required by the frontend in order to show images */
  [IMG_URI]?: string | null;
}

export enum CartItemType {
  similar = 'similar',
  existing = 'existing',
  concept = 'concept',
}
export interface CartItem {
  children?: any[];
  id: string;
  _id: string;
  name: string;
  imgSrc: string;
  description: string;
  swatches: ColorSwatchItem[];
  currentChildren: ColorSwatchItem[];
  currentAssortmentChildren?: ColorSwatchItem[];
  type: CartItemType;
  valid: boolean;
  activePowerdriverIndex?: number;
}
